const diningMainPeople = (flr) => {

  const pageOutdoorDining = document.getElementById('pageOutdoor-dining');
  if (pageOutdoorDining) {


    let secMain = document.getElementById('jsSecMain');
    let jsPeople;

    if (flr == '1f') {
      jsPeople = secMain.querySelectorAll('.js-people-box-1f');
    } else if (flr == '2f') {
      jsPeople = secMain.querySelectorAll('.js-people-box-2f');
    }


    // console.log(jsPeople);


    const moveStart = (elem) => {
      let i = elem.querySelector('i');
      i.className = 'act'
    }
    const moveStop = (elem) => {
      let i = elem.querySelector('i');
      i.classList.add('stop');
    }
    const moveReset = (elem) => {
      elem.classList.remove('act')
      let i = elem.querySelector('i');
      setTimeout(() => {
        i.classList.remove('act')
      }, 1000)
    }

    const moveLoop = (elem, time, func) => {
      let diff = 3000
      elem.classList.add('act')
      moveStart(elem)

      if (time !== 0) {
        setTimeout(() => {
          moveStop(elem)
        }, time)
        setTimeout(() => {
          moveReset(elem)
        }, time + diff)
        setTimeout(() => {
          func()
        }, time + diff * 2)
      }
    }


    if (flr == '1f') {

      const people6 = () => {
        let elem = jsPeople[6]
        let time = 0
        moveLoop(elem, time, people6)
      }
      people6()

      const people10 = () => {
        let elem = jsPeople[10]
        let time = 0
        moveLoop(elem, time, people10)
      }
      people10()

      const people11 = () => {
        let elem = jsPeople[11]
        let time = 21600
        moveLoop(elem, time, people11)
      }
      people11()

      const people15 = () => {
        let elem = jsPeople[15]
        let time = 0
        moveLoop(elem, time, people15)
      }
      people15()

      const people18 = () => {
        let elem = jsPeople[18]
        let time = 64800
        moveLoop(elem, time, people18)
      }
      people18()

      const people30 = () => {
        let elem = jsPeople[30]
        let time = 54000
        moveLoop(elem, time, people30)
      }
      people30()

      const people31 = () => {
        let elem = jsPeople[31]
        let time = 54000
        moveLoop(elem, time, people31)
      }
      people31()

    } else if (flr == '2f') {

      const people0 = () => {
        let elem = jsPeople[0]
        let time = 0
        moveLoop(elem, time, people0)
      }
      people0()

      const people2 = () => {
        let elem = jsPeople[2]
        let time = 0
        moveLoop(elem, time, people2)
      }
      people2()

      const people3 = () => {
        let elem = jsPeople[3]
        let time = 0
        moveLoop(elem, time, people3)
      }
      people3()

      const people8 = () => {
        let elem = jsPeople[8]
        let time = 8100
        moveLoop(elem, time, people8)
      }
      people8()

      const people9 = () => {
        let elem = jsPeople[9]
        let time = 0
        moveLoop(elem, time, people9)
      }
      people9()

      const people10 = () => {
        let elem = jsPeople[10]
        let time = 65000
        moveLoop(elem, time, people10)
      }
      people10()

      const people14 = () => {
        let elem = jsPeople[14]
        let time = 26200
        moveLoop(elem, time, people14)
      }
      people14()

    }


  }

}
export default diningMainPeople;